import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GridColumn } from '@progress/kendo-react-grid';
import { successNotification, errorNotification, warningNotification } from '../../notification';
import { FormFieldDrop, FormFieldGeneric } from '../../formField';
import FormRow from '../../formRow';
import Popup from '../layout';
import GridInline from '../../grid';
import CustomLabel from '../../formField/components/label';
import * as relationshipService from '../../../services/relationship';
import * as walletService from '../../../services/wallet';
import { useForms } from '../../../hooks';
import LoadScreen from '../../../view/load';

const initialForm = {
  Nome: '',
  ListaIdUsuario: []
};

const PopUpRelationshipType = ({
  visible,
  setVisible,
  reloadRelationshipTypes,
  isEdit,
  entity
}) => {
  const [form, updateForm, setForm] = useForms(initialForm);
  const [responsibles, setResponsibles] = useState([]);
  const [loading, setLoading] = useState(false);

  const createRelationshipType = async (body) => {
    const response = await relationshipService.createRelationshipType(body);
    const { data } = response;
    if (response.status === 200) {
      body = {
        ...data,
        Editavel: true
      };
      successNotification('Tipo de registro criado com sucesso!');
      await reloadRelationshipTypes(body);
    } else if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
    else errorNotification('Houve um erro ao tentar atualizar um tipo de registro.');
  };

  const editRelationshipType = async (body) => {
    const response = await relationshipService.updateRelationshipType(body, body.Id);
    const { data } = response;
    if (response.status === 200) {
      body = {
        ...data,
        Editavel: true
      };
      successNotification('Tipo de registro atualizado com sucesso!');
      await reloadRelationshipTypes(body);
    } else if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
    else errorNotification('Houve um erro ao tentar atualizar um tipo de registro.');
  };

  const excludeRelationshipType = async () => {
    const response = await relationshipService.excludeRelationshipType(entity.Id);
    if (response.status === 200) {
      successNotification('Tipo de registro excluído com sucesso!');
      await reloadRelationshipTypes(null);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir um tipo de registro.');
    }
  };

  const loadResponsibles = async (entity) => {
    setLoading(true);
    let { data } = await walletService.getUsers();
    data = data.map((item) => {
      item.Confirmado = entity?.Usuario?.some((obj) => obj.Email === item.Email);
      return item;
    });
    setResponsibles(data);
    setLoading(false);
    return data;
  };

  const onSelectionChange = (event) => {
    const newData = responsibles.map((item) => {
      if (item.Id === event.dataItem.Id) {
        item.Confirmado = !item.Confirmado;
      }
      return item;
    });
    setResponsibles(newData);
  };

  const onHeaderSelectionChange = (event) => {
    const { checked } = event.syntheticEvent.target;
    const newData = responsibles.map((item) => {
      item.Confirmado = checked;
      return item;
    });
    setResponsibles(newData);
  };

  const submitHandle = () => {
    const ids = responsibles.filter(({ Confirmado }) => Confirmado).map((item) => item.Email);
    const body = {
      ...form,
      Id: entity?.Id,
      ListaIdUsuario: ids
    };

    return isEdit ? editRelationshipType(body) : createRelationshipType(body);
  };

  useEffect(async () => {
    setForm(entity || initialForm);
    if (visible) await loadResponsibles(entity || initialForm);
  }, [entity, visible]);

  return (
    <Popup
      visible={visible}
      setVisible={setVisible}
      title="Tipo de Registro"
      confirmText="Salvar"
      cancelText="Cancelar"
      haveExclude={isEdit}
      onConfirm={submitHandle}
      onDelete={excludeRelationshipType}
    >
      <FormRow>
        <FormFieldGeneric
          titleLabel="Nome"
          classNameWrapper="fill-100-field-tooltip"
          name="Nome"
          onChangeValue={updateForm}
          valueInput={form.Nome}
          required
        />
      </FormRow>
      <FormRow>
        <CustomLabel>Associação de Usuários</CustomLabel>
      </FormRow>
      {loading ? (
        <LoadScreen />
      ) : (
        <FormRow>
          <GridInline
            data={responsibles}
            setData={setResponsibles}
            selectedField="Confirmado"
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
          >
            <GridColumn
              field="Confirmado"
              editable={false}
              headerSelectionValue={responsibles.findIndex((item) => !item.Confirmado) === -1}
            />
            <GridColumn field="Nome" title="Nome" editable={false} />
          </GridInline>
        </FormRow>
      )}
    </Popup>
  );
};

PopUpRelationshipType.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reloadRelationshipTypes: PropTypes.func.isRequired
};

export default PopUpRelationshipType;
